<ng-container [ngSwitch]="view">
  <ng-container *ngSwitchCase="viewModes.detail">
    <ng-container *ngTemplateOutlet="debateDetailTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="debatesViewTemplate"></ng-container>
  </ng-container>
</ng-container>

<ng-template #debatesViewTemplate>
  <div class="tutorization--block__column margin-top">
    <div *ngIf="stats" class="tutorization--block__row">
      <ng-container
        *ngTemplateOutlet="
          debatesStatsWidget;
          context: {
            title: 'debates.widgets.totalDebates',
            value: stats.totalDebates,
            label: 'debates.widgets.debates'
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          debatesStatsWidget;
          context: {
            title: 'debates.widgets.meanVotesDebates',
            value: stats.totalDebates ? stats.totalVotes / stats.totalDebates : 0,
            label: 'debates.widgets.votes'
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          debatesStatsWidget;
          context: {
            title: 'debates.widgets.certifiedDebates',
            value: stats.totalCertified,
            label: 'debates.widgets.debates'
          }
        "
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          debatesStatsWidget;
          context: { title: 'debates.widgets.cancelled', value: stats.totalCancelled, label: 'debates.widgets.debates' }
        "
      ></ng-container>
    </div>
  </div>

  <lms-toolbar [options]="toolbarConfig"></lms-toolbar>

  <div class="gl-table__container">
    <gl-table
      [id]="listId"
      [dataSource]="dataSource"
      data-testid="marsTutorizationDebatesTable"
      [placeholder]="'actions.noResultTable' | translate"
      paginator
    >
    </gl-table>
  </div>
</ng-template>

<ng-template #debateDetailTemplate>
  <lms-toolbar>
    <h1 left class="h1 margin-left">{{ 'nouns.debate' | translate }}</h1>
    <div class="lms-toolbar__item">
      <gl-button
        color-tertiary
        [text]="'actions.back' | translate"
        (onClick)="editDebate()"
        title="{{ 'actions.back' | translate }}"
      ></gl-button>
    </div>
  </lms-toolbar>
  <div class="tutorization--block__column margin-top">
    <lms-mars-debate [debate]="selectedDebate" (updated)="onDebateUpdated($event)"> </lms-mars-debate>
  </div>
</ng-template>

<ng-template #debatesStatsWidget let-title="title" let-value="value" let-label="label">
  <div class="tutorization--block__item">
    <div class="dashboard-card-item">
      <div class="dashboard-card-item-title text-centered">{{ title | translate }}</div>
      <div class="dashboard-card-item-text text-centered">{{ value }}</div>
      <div class="dashboard-card-item-label">{{ label | translate }}</div>
    </div>
  </div>
</ng-template>
